import API from "@/services/api";
import { Address, PoblacioINE, Provincia, Tipovias } from "../types/address";
import { EndpointsAddress } from "./endpoints";

export const fetchPoblacionsINE = (
  zipcode: string
) => {
  return new Promise<PoblacioINE[]>(async (resolve, reject) => {
    API.get<PoblacioINE[]>({
      endpoint: EndpointsAddress.Poblacions,
      params: {
        zipcode
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const fetchProvincies = (
  stateCode: string
) => {
  return new Promise<Provincia[]>(async (resolve, reject) => {
    API.get<Provincia[]>({ // fix this
      endpoint: EndpointsAddress.Provincies,
      params: {
        ine: stateCode
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const fetchTipovias = () => {
  return new Promise<Tipovias[]>(async (resolve, reject) => {
    API.get<Tipovias[]>({
      endpoint: EndpointsAddress.Tipovias,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchPoblacionsINE,
  fetchProvincies,
  fetchTipovias
};


